module.exports = __webpack_public_path__ + "static/media/blingV3_14.11fbbbc2.png";